<template>
    <div
        v-if="count > 0"
        class="foulCard"
        v-bind:class="{ _away: isAway }"
    >
        <div
            v-for="index in count"
            v-bind:key="index"
            class="foulCard-item"
        />
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        isAway: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            required: true,
        },
    });
</script>

<style lang="scss" scoped>
@import "@/components/common/foulCard/FoulCard";
</style>
